// extracted by mini-css-extract-plugin
module.exports = {"container":"_2gTG3PKCMKx7xfuC1_eac","title":"OwxfXq6fku4iiWghpba9A"};